import * as Mod1 from "./discourse/components/modal/delete-uploads-modal";
import * as Mod2 from "./discourse/connectors/reviewable-item-actions/legal-compliance-delete-uploads-button.gjs";
import * as Mod3 from "./discourse/initializers/init-legal-compliance";
const compatModules = {
  "discourse/components/modal/delete-uploads-modal": Mod1,
  "discourse/connectors/reviewable-item-actions/legal-compliance-delete-uploads-button": Mod2,
  "discourse/initializers/init-legal-compliance": Mod3,
};
export default compatModules;
